// eslint-disable-next-line import/prefer-default-export,@typescript-eslint/naming-convention
export const MAX_ITEMS_TO_COMPARE = 4;
